<div class="main-setting">
    <p-tabView>
        <p-tabPanel header="Pages List Config" i18n-header="@@Pages List Config">
            <div class="pages_list">
                <div class="col-12">
                    <div><label i18n="@@News">News</label></div>
                    <textarea [(ngModel)]="listPagesConfig.news.text">
                </textarea>
                </div>
                <div class="col-12">
                    <div><label i18n="@@Customers">Customers</label></div>
                    <textarea [(ngModel)]="listPagesConfig.customers.text">
                </textarea>
                </div>
                <div class="col-12">
                    <div><label i18n="@@Success Story">Success Story</label></div>
                    <textarea [(ngModel)]="listPagesConfig.success.text">
                </textarea>
                </div>
                <div class="col-12">
                    <div><label i18n="@@Service Features">Service Features</label></div>
                    <textarea [(ngModel)]="listPagesConfig.features.text">
                </textarea>
                </div>
                <div class="col-12">
                    <div><label i18n="@@Blog">Blog</label></div>
                    <textarea [(ngModel)]="listPagesConfig.blogs.text">
                </textarea>
                </div>
                <div class="col-12">
                    <div><label i18n="@@Other Page">Other Page</label></div>
                    <textarea [(ngModel)]="listPagesConfig.pages.text">
                </textarea>
                </div>
                <div class="col-12">
                    <button class="button darkblue" (click)="savePagesList()"><span i18n="@@Save">Save</span></button>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Dashboard Info" i18n-header="@@Dashboard Info">
            <div class="pages_list">
                <div class="col-12">
                    <div><label i18n="@@Dashboard Login Address" >Dashboard Login Address</label></div>
                    <input style="width: 100%" [(ngModel)]="dashboardSetting.loginUrl">
                </div>
                <div class="col-12">
                    <button class="button darkblue" (click)="saveDashboardSetting()"><span i18n="@@Save">Save</span></button>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>
